import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=b8f6d0be&scoped=true&"
import script from "./HeaderNotification.vue?vue&type=script&lang=js&"
export * from "./HeaderNotification.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=b8f6d0be&scoped=true&lang=css&"
import style1 from "./HeaderNotification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f6d0be",
  null
  
)

export default component.exports